export default __webpack_public_path__ + "static/media/2.f8102851.jpg";